export default "__VITE_ASSET__BbO2zg7U__"